"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loader(_ref) {
  var large = _ref.large,
      light = _ref.light,
      negative = _ref.negative;
  var className = (0, _utils.getClassNames)('loader', {
    'loader-large': large
  }, {
    'loader-light': light
  }, {
    'loader-negative': negative
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-circle"
  })));
}

Loader.propTypes = {
  /** The size of loader */
  large: _propTypes.default.bool,

  /** The color of loader */
  light: _propTypes.default.bool,

  /** The color of loader */
  negative: _propTypes.default.bool
};
Loader.defaultProps = {
  large: false,
  light: false,
  negative: false
};
var _default = Loader;
exports.default = _default;